import { isServer } from 'lit';

class DeepSlotChangeController {
  get _slotsToObserve() {
    if (!this._slotNames.length) {
      return [this._host];
    }
    const slots = this._slotNames.map((slotName) => {
      if (slotName === "default") {
        return ":not([slot])";
      }
      return `[slot="${slotName}"]`;
    }).reduce((acc, selector) => [...acc, ...Array.from(this._host.querySelectorAll(selector))], []).filter((slot) => !!slot);
    return slots;
  }
  constructor({
    callback,
    host,
    slotNames = []
  }) {
    this._host = host;
    this._slotNames = slotNames;
    this._mutationObservers = !isServer ? this._slotsToObserve.map(() => new MutationObserver(callback)) : [];
    this._host.addController(this);
  }
  hostConnected() {
    const mutationOptions = {
      attributes: true,
      childList: true,
      subtree: true
    };
    this._mutationObservers.forEach(
      (observer, index) => observer.observe(this._slotsToObserve[index], mutationOptions)
    );
  }
  hostDisconnected() {
    this._mutationObservers.forEach((observer) => observer.disconnect());
  }
}

export { DeepSlotChangeController };
